import cookie from 'js-cookie'
import { GetServerSidePropsContext } from 'next/types'

import { getCurrencyByCountry } from './getCurrencyByCountry'
import { isSupportedCurrency, SupportedCurrencies } from './price-table'

const COOKIE_KEY_CURRENCY = 'tw_currency'

export function getSessionCurrency(context: GetServerSidePropsContext): SupportedCurrencies {
    const allCookies = context.req.cookies
    const cookieCurrency = allCookies[COOKIE_KEY_CURRENCY]

    if (cookieCurrency && isSupportedCurrency(cookieCurrency)) {
        return cookieCurrency as SupportedCurrencies
    }

    const country = context.req.headers['cloudfront-viewer-country'] as string | undefined
    const currency = getCurrencyByCountry(country)

    return currency
}

export function setSessionCurrency(currency: SupportedCurrencies) {
    cookie.set(COOKIE_KEY_CURRENCY, currency)
}
